import { Injectable } from "@angular/core";
import { UUID } from "angular2-uuid";
import { Product } from "../models/product";
import { ProductService } from "./product.service";
import { Subject, Subscription } from "rxjs";
import { DataService } from "./data.service";

@Injectable({
  providedIn: "root",
})
export class ShoppingCartService {
  CART = {
    cartId: this.generateUUID(),
    contents: [],
  };
  cartItems: any = [];
  cartId: string;

  subscription: Subscription;
  products: any = [];
  constructor(
    private productService: ProductService,
    private dataService: DataService
  ) {
    this.productService.getAll().subscribe((products) => {
      this.products = products.data;
    });
  }

  ////////?????????///////////////?????//////////

  init() {
    //check localStorage and initialize the contents of CART.contents
    let _contents = localStorage.getItem(this.getOrCreateCartId());
    if (_contents) {
      this.cartItems = JSON.parse(_contents);
    } else {
      //dummy test data
      this.cartItems = [];
      this.updateStorage();
    }
  }

  updateStorage() {
    let _cart = JSON.stringify(this.cartItems);
    localStorage.setItem(this.cartId, _cart);
    this.dataService.cartQtySubject.next(this.totalItemsCount);
    this.dataService.cartPriceSubject.next(this.totalPrice);
    this.dataService.cartVatPriceSubject.next(this.totalPriceWithVat);
    this.dataService.cartItemsSubject.next(this.cartItems);
    this.dataService.setCartItems(this.cartItems);
    this.dataService.vatTotalSubject.next(this.totalVat);
  }

  find(id: number) {
    //find an item in the cart by it's id
    let match = this.cartItems.filter((item) => {
      if (item.id == id) return true;
    });
    if (match && match[0]) return match[0];
  }

  add(id: number, variation?) {
    //add a new item to the cart
    //check that it is not in the cart already
    let currentQuantity = this.singleItemCount(id)+1;
    let productDetails = this.products.filter((product) =>product.id == id);
    console.log({productDetails});
    
    if (productDetails.length) {
      let details = productDetails[0];
      const obj = {
        id: details.id,
        title: details.name,
        quantity: 1,
        itemPrice: details.price,
        image: details.image,
        code: details.code,
        hasVat: details.has_vat,
        vatAmount: details.vat_amount,
        itemPriceWithVat: +details.vat_amount + +details.price,
        stockQuantity: details.quantity,
        no_qty_limit: details.no_qty_limit,
        currency: details.currency,
        ready_to_ship: details.ready_to_ship,
        production_no_of_days: details.production_no_of_days
      };
      let cartItem = {...obj};

      let minimumOrdeQuantity = productDetails.length ? productDetails[0].minimum_order_quantity:null;
      if (minimumOrdeQuantity && currentQuantity >= minimumOrdeQuantity){
        const newPrice = +details.wholesale_price;
        cartItem = {...obj, ...{itemPriceWithVat: newPrice, itemPrice: newPrice} }
      }

      if (this.find(id)) {
        this.increase(id, 1);
        this.dataService.cartQtySubject.next(this.totalItemsCount);
      } else {
        if (variation) {
          console.log("variation item", variation);
          cartItem = {...obj, ...{
            itemPriceWithVat:variation.price + +variation.vat_amount, 
            itemPrice: variation.price,image: variation.image, 
            variation_id: variation.id,
          }}
        } else {
          // simple item
        }
        this.cartItems.push(cartItem);
          //update localStorage
        this.updateStorage();
        this.dataService.cartQtySubject.next(this.totalItemsCount);
      }
    }


  }

  increase(id, qty = 1, variation?) {
    //increase the quantity of an item in the cart
    let productDetails = this.products.filter((product) =>product.id == id);
    
    if (productDetails.length) {
      let details =  productDetails[0];
      let productHasVat = details.has_vat;
      console.log({productHasVat});
      
      let minimumOrdeQuantity = details.minimum_order_quantity;
      let currentQuantity = this.singleItemCount(id) + qty;
      let newPrice = details.price;
      let itemVatPrice = parseFloat(details.price) + parseFloat(details.vat_amount);
     
      
      
      if (minimumOrdeQuantity && currentQuantity >= minimumOrdeQuantity){
        itemVatPrice =  parseFloat(details.wholesale_price);
        console.log(itemVatPrice);
        newPrice = +details.wholesale_price; 
      }
     
      this.cartItems = this.cartItems.map((item) => {
        if (item.id === id) {
          item.quantity = item.quantity + qty;
          if (!variation) {
            item.itemPriceWithVat = itemVatPrice
            item.price = newPrice
          }
        }
        return item;
      });
      //update localStorage
      this.updateStorage();
    }
  }

  reduce(id, qty = 1, variation?) {
    //reduce the quantity of an item in the cart
    let productDetails = this.products.filter((product) =>product.id == id);
    if (productDetails.length) {
      let details =  productDetails[0];
      let productHasVat = details.has_vat;
      let minimumOrdeQuantity = details.minimum_order_quantity;
      let currentQuantity = this.singleItemCount(id) - qty;
      let newPrice = details.price;
      let itemVatPrice = parseFloat(details.price) + parseFloat(details.vat_amount);
      if (minimumOrdeQuantity && currentQuantity >= minimumOrdeQuantity){
        itemVatPrice =  parseFloat(details.wholesale_price);
        newPrice = parseFloat(details.wholesale_price); 
      }
      this.cartItems = this.cartItems.map((item) => {
        if (item.id === id) {
          item.quantity = parseInt(item.quantity) - qty;
          if (minimumOrdeQuantity){
            item.itemPriceWithVat = itemVatPrice
            item.price = newPrice
          }
        }
        return item;
      });
      this.cartItems.forEach(async (item) => {
        if (item.id === id && item.quantity === 0) await this.remove(id);
      });
      //update localStorage
      this.updateStorage();
    }

    // this.cartItems = this.cartItems.map((item) => {
    //   if (item.id === id) item.quantity = item.quantity - qty;
    //   return item;
    // });
    // this.cartItems.forEach(async (item) => {
    //   if (item.id === id && item.quantity === 0) await this.remove(id);
    // });
    // //update localStorage
    // this.updateStorage();
  }

  remove(id) {
    //remove an item entirely from CART.contents based on its id
    this.cartItems = this.cartItems.filter((item) => {
      if (item.id !== id) return true;
    });
    //update localStorage
    this.updateStorage();
  }

  empty() {
    //empty whole cart
    this.cartItems = [];
    //update localStorage
    this.updateStorage();
  }

  /////////////??////////////????????////////////////

  getOrCreateCartId() {
    let cartId = localStorage.getItem("cartId");
    if (cartId) {
      this.cartId = cartId;
      return cartId;
    }

    this.cartId = this.generateUUID();
    localStorage.setItem("cartId", this.cartId);
    return this.cartId;
  }

  private getItem(cartId: string, productId: number) {
    // return this.db.object("/shopping-carts/" + cartId + "/items/" + productId);
    // return a particular object
    this.cartItems.filter((item) => {
      if (item.id === cartId) return true;
    });

    return this.cartItems;
  }

  get totalPrice() {
    let sum = 0;
    for (let productId in this.cartItems)
      sum +=
        this.cartItems[productId].itemPrice *
        this.cartItems[productId].quantity;
    return sum;
  }

  get totalPriceWithVat() {
    let sum = 0;
    for (let productId in this.cartItems)
      sum +=
        this.cartItems[productId].itemPriceWithVat *
        this.cartItems[productId].quantity;
    return sum;
  }

  get totalVat() {
    let sum = 0;
    for (let productId in this.cartItems)
      sum +=
        this.cartItems[productId].vatAmount *
        this.cartItems[productId].quantity;
    return sum;
  }

  get totalItemsCount() {
    let count = 0;
    for (let productId in this.cartItems) {
      count += this.cartItems[productId].quantity;
    }
    return count;
  }

  generateUUID() {
    return UUID.UUID();
  }

  singleItemCount(aProductId:number) {
    // return aProductId;
    let cartProduct = this.cartItems.filter((item: { id: number; })=>item.id == aProductId) 
    if (cartProduct.length){
      cartProduct = cartProduct[0];
    }
    return cartProduct.quantity || 0;
  }
  
}
